import { Mail, MapPin, Phone, MessageCircle } from 'lucide-react';

export const waLink = (num) => {
  let d = (num || '').replace(/\D/g, '');
  if (d.startsWith('0')) d = `90${d.slice(1)}`;
  if (d.length === 10) d = `90${d}`;
  return `https://wa.me/${d}`;
};

const Item = ({ icon: Icon, label, value, href, testId }) => (
  <a href={href} className="flex items-start gap-3 p-4 rounded-xl bg-white/[0.03] border border-white/10 hover:border-emerald-400/50 transition-colors" data-testid={testId}>
    <div className="w-10 h-10 rounded-lg bg-emerald-500/15 flex items-center justify-center flex-shrink-0"><Icon className="h-5 w-5 text-emerald-400" /></div>
    <div className="min-w-0">
      <p className="text-[11px] uppercase tracking-wider text-slate-500">{label}</p>
      <p className="text-white text-sm font-medium break-words">{value}</p>
    </div>
  </a>
);

export const ContactSection = ({ contact }) => {
  const c = contact || {};
  if (!c.phone && !c.whatsapp && !c.email && !c.address) return null;
  return (
    <section id="iletisim" className="max-w-6xl mx-auto px-5 sm:px-8 py-16" data-testid="landing-contact-section">
      <p className="text-emerald-400 text-xs font-bold uppercase tracking-[0.2em] mb-2">İletişim</p>
      <h2 className="text-2xl sm:text-3xl font-bold text-white mb-8">Bize ulaşın</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {c.phone && <Item icon={Phone} label="Telefon" value={c.phone} href={`tel:${c.phone.replace(/\s/g, '')}`} testId="landing-contact-phone" />}
        {c.whatsapp && <Item icon={MessageCircle} label="WhatsApp" value={c.whatsapp} href={waLink(c.whatsapp)} testId="landing-contact-whatsapp" />}
        {c.email && <Item icon={Mail} label="E-posta" value={c.email} href={`mailto:${c.email}`} testId="landing-contact-email" />}
        {c.address && <Item icon={MapPin} label="Adres" value={c.address} href={`https://maps.google.com/?q=${encodeURIComponent(c.address)}`} testId="landing-contact-address" />}
      </div>
    </section>
  );
};

export const WhatsAppFab = ({ number }) => (number ? (
  <a href={waLink(number)} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp ile yazın"
    className="fixed bottom-5 right-5 z-50 w-14 h-14 rounded-full bg-[#25D366] hover:scale-110 transition-transform shadow-2xl flex items-center justify-center"
    data-testid="landing-whatsapp-fab">
    <MessageCircle className="h-7 w-7 text-white" />
  </a>
) : null);
